import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, homeForRole } from "@/lib/auth";
import { useT } from "@/lib/prefs";
import { Logo, Button, Field } from "@/components/brand";

export default function Login() {
  const t = useT();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      window.location.assign(homeForRole(u.role));
    } catch (err) {
      toast.error(err.message || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-white" data-testid="login-screen">
      <div className="w-full max-w-md">
        <Link to="/"><Logo size={34} /></Link>
        <h1 className="font-display text-4xl text-ink tracking-tight mt-8">{t("auth.welcomeBack")}</h1>
        <p className="font-body text-mutedgrey mt-1">{t("auth.loginSub")}</p>
        <form onSubmit={submit} className="flex flex-col gap-4 mt-8">
          <Field label={t("auth.email")} testID="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />
          <Field label={t("auth.password")} testID="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••" required />
          <Button testID="login-submit" type="submit" title={t("auth.login")} loading={loading} full />
        </form>
        <p className="font-body text-sm text-mutedgrey text-center mt-6">
          {t("auth.joinSub")} <Link to="/register" data-testid="login-to-register" className="font-semibold text-brand">{t("auth.join")}</Link>
        </p>
      </div>
    </div>
  );
}
